module.exports = __webpack_public_path__ + "static/media/blogThumbnail1.4556ab06.jpg";